import React from "react";

/**
 * Wraps occurrences of `query` (case-insensitive) and any extra `keywords`
 * inside `text` with an amber highlight (per design guidelines).
 */
export default function Highlight({ text, query = "", keywords = [], className = "" }) {
  if (!text) return null;
  const terms = [query, ...keywords].map((t) => (t || "").trim()).filter(Boolean);
  if (terms.length === 0) return <span className={className}>{text}</span>;

  // Build a single regex of all terms, escaped.
  const escaped = terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const re = new RegExp(`(${escaped.join("|")})`, "gi");
  const parts = text.split(re);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        const isMatch = terms.some((t) => t.toLowerCase() === part.toLowerCase());
        return isMatch ? (
          <mark
            key={i}
            className="bg-amber-200 text-amber-900 font-semibold px-1 py-0.5 rounded-sm"
            data-testid="keyword-highlight"
          >
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        );
      })}
    </span>
  );
}
